import type { QuizType } from '@ts-types/quiz/types'

export const getDataQA = (quizType: QuizType, name: string) => {
  switch (quizType) {
    case 'default':
      return name
    case 'registration-quiz':
      return name
    default:
      return null
  }
}